var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleBlueView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.16 0 0 7.16 0 16c.838 21.225 31.165 21.219 32 0 0-8.84-7.16-16-16-16zm10.29 16.35c-3.562 9.462-17.02 9.46-20.58 0a.94.94 0 0 1 0-.7C7.31 11.38 11.45 8.5 16 8.5s8.69 2.88 10.29 7.15c.09.23.09.47 0 .7z",
    fill: "#8fa8bb",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.5c-3.6 0-6.88 2.2-8.28 5.5 1.4 3.3 4.68 5.5 8.28 5.5s6.88-2.2 8.28-5.5c-1.4-3.3-4.68-5.5-8.28-5.5zm0 9.99c-5.935-.183-5.934-8.798 0-8.98 5.935.183 5.934 8.798 0 8.98z",
    fill: "#8fa8bb",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13.51c-3.282.09-3.282 4.89 0 4.98 3.282-.09 3.282-4.89 0-4.98z",
    fill: "#8fa8bb",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBlueView);
export default __webpack_public_path__ + "static/media/circle-blue-view.ed605db249e64c3e2b6dc477610acc99.svg";
export { ForwardRef as ReactComponent };